import { createContext, useContext } from 'react'
import { makeTuple } from '../tsUtils'

export const createContextWithoutDefault = <T,>(contextName: string) => {
	// Permet de créer un contexte sans valeur par défaut. Si on tente d'utiliser le hook correspondant en dehors d'un provider une erreur sera lancée
	const sym = Symbol(contextName)

	const context = createContext<T | typeof sym>(sym)

	const useContextWithCheck = (): T => {
		const fichesContext = useContext(context)
		if (fichesContext === sym) {
			throw new Error(`le hook use${contextName} must be used within a ${contextName}Context`)
		}
		return fichesContext
	}

	return makeTuple(context, useContextWithCheck)
}
